import { GlobeAltIcon, HomeIcon } from '@heroicons/react/24/outline';

import { Sidebar } from '@/components/layout/Sidebar';
import { CanvasRoutes, RouterConfig, Routes } from '@/configs/routes';

const items = Routes.filter((r) => r.showInNavigation && r.path.startsWith('/forecasts/'));

const iconMap = {
  [RouterConfig[CanvasRoutes.FoundationForecastingHome].path]: HomeIcon,
  [RouterConfig[CanvasRoutes.ForecastExplorer].path]: GlobeAltIcon,
};

export function FoundationForecastingSidebar() {
  return <Sidebar label="Foundation Forecasting" items={items} iconMap={iconMap} depth={1} />;
}
